<template>
  <div class="d-inline">
    <b-button variant=" mr-1 mb-1 " @click="openModal" title="Sync Result"><i class="fa fa-refresh font-size-20" aria-hidden="true"></i></b-button>
    <b-modal
      v-model="showModal"
      title="Sync App Results"
      size="md"
      @hidden="resetModal"
    >
      <!-- App Info Alert -->
      <div class="alert alert-primary" role="alert">
        <small>
          <strong>App :</strong>
          <span class="text-dark font-weight-bold">
            &nbsp;{{ propAppData?.app_name || 'N/A' }}&nbsp;
          </span>
          <br />
          <span class="text-secondary">
            Select date range to sync results
          </span>
        </small>
      </div>

      <!-- App Details -->
      <div class="mb-3">
        <h6>
          <strong>App ID &nbsp;:</strong>
          <span class="text-secondary">&nbsp;{{ propAppData?.app_id }}&nbsp;</span>
        </h6>
      </div>

      <!-- Date Picker -->
      <div class="mb-3 w-100">
        <label class="h6 font-weight-bold">Select Date Range :</label>

        <div class="dateRange mb-2 col-12">
          <b-col class="w-100 p-0">
            <date-range-picker opens="right" class="w-100" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="dateRange"  @update="handleDateChange" ></date-range-picker>
          </b-col>
        </div>

        <small class="form-text text-muted">
          Please select a valid date range to sync results
        </small>
      </div>

      <!-- Error -->
      <div v-if="errorMsg" class="alert alert-danger">
        {{ errorMsg }}
      </div>

      <!-- Footer -->
      <template #modal-footer>
        <b-button size="sm" @click="closeModal">
          Cancel
        </b-button>

        <b-button size="sm" variant="primary" @click="submitSync">
          <span v-if="isLoading">
            <b-spinner small class="mr-2"></b-spinner>
            Syncing...
          </span>
          <span v-else>Sync Data</span>
        </b-button>
      </template>
    </b-modal>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import moment from "moment"
import { AppResults } from "../../../FackApi/api/appResults"

export default {
  name: "AppSyncModal",

  props: {
    propAppData: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      showModal: false,
      dateRange: {
        startDate: moment().subtract(365, "days"),
        endDate: moment().add(1, "days")
      },
      isLoading: false,
      errorMsg: "",
      toastMsg: null,
      showToast: false,
      toastVariant: "default",
      toastTitle: "Sync App Results"
    }
  },

  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  methods: {
    /**
     * openModal
     */
    openModal () {
      this.showModal = true
    },
    /**
     * closeModal
     */
    closeModal () {
      this.showModal = false
    },
    /**
     * resetModal
     */
    resetModal () {
      this.dateRange = null
      this.errorMsg = ""
      this.isLoading = false
    },
    /**
     * handleDateChange
     */
    handleDateChange () {
      this.errorMsg = ""
    },
    /**
     * submitSync
     */
    async submitSync () {
      try {
        if (!this.dateRange) {
          this.errorMsg = "Please select a date range"
          return
        }

        this.isLoading = true

        const payload = {
          app_id: this.propAppData.app_id,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate
        }

        const resultSyncResp = await AppResults.appResultSync(this, payload)
        if (resultSyncResp.resp_status) {
          this.showToast = true
          this.toastMsg = "App results synced successfully"
          this.toastVariant = "success"
          this.closeModal()
        }
      }
      catch (error) {
        this.toastMsg = "Error occurred while syncing app results"
        this.toastVariant = "danger"
        this.showToast = true
        console.error("Error occurred while syncing app results:", error)
      }
      finally {
        this.isLoading = false
      }
    }
  }
}
</script>
